module.exports = __webpack_public_path__ + "files/38f6704695d61b9fb4292a1c51e2baf2.png";